import furnitureStoreImg from "./img/furniture-store.png";
import searchGithubUsers from "./img/github-search-users.png";
import adminDashboard from "./img/admin-dashboard.png";

export const products = [
  {
    id: 1,
    img: furnitureStoreImg,
    link: "https://furnitures-house.netlify.app/",
  },
  {
    id: 2,
    img: searchGithubUsers,
    link: "https://do-search-users.netlify.app/",
  },
  {
    id: 3,
    img: adminDashboard,
    link: "https://my-mui-dashboard.netlify.app/",
  },
  // {
  //   id: 4,
  //   img: "",
  //   link: "http://lama.dev",
  // },
  // {
  //   id: 5,
  //   img: "",
  //   link: "http://lama.dev",
  // },
  // {
  //   id: 6,
  //   img: "",
  //   link: "http://lama.dev",
  // },
];
